import SuggestionImport from './suggestionimport'

export default SuggestionImport